import tabAppFailedTransactions from './tabAppFailedTransactions';
import tabAppTransactions from './tabAppTransactions';
import tableAppTransactions from './tableAppTransactions';

export default {
  title: 'Manual V.T. Transactions',
  attributeName: 'appTransaction',
  getURL: 'appId/appTransaction',
  updateURL: 'appId/appTransaction',
  sessionParams: ['appId'],
  noArea: true,
  tabs: [tabAppTransactions, tabAppFailedTransactions],
  tableConfig: tableAppTransactions,
  initialTab: 'successful',
};
